import PropTypes from "prop-types";
import React from "react";
import cx from "classnames";

export default class ResultItem extends React.Component {
  constructor(props) {
    super(props);
    this.itemWrapper = null;
  }

  componentDidMount() {
    this.itemWrapper.className = this.itemWrapper.className + " is-visible";
  }

  renderEyebrow() {
    const { contentType, date, authors, clients } = this.props;

    return (
      <div className="list-item__eyebrow-area">
        {contentType && (
          <span className="list-item__content-type">{contentType}</span>
        )}
        {date && <span className="list-item__date">{date}</span>}
        {authors && authors.length > 0 && (
          <span className="list-item__authors">By: {authors.join(", ")}</span>
        )}
        {clients && clients.length > 0 && (
          <span className="list-item__clients">
            Client: {clients.join(", ")}
          </span>
        )}
      </div>
    );
  }

  render() {
    const { title, body, contentUrl, featured, imageSrcWide } = this.props;

    return (
      <div
        className={cx("list-item list-item--search", {
          "list-item--featured is-dark-mode": featured,
        })}
        ref={(el) => (this.itemWrapper = el)}
      >
        {this.renderEyebrow()}
        <div className="list-item__title">
          <a className="list-item__cta" href={contentUrl}>
            {title}
          </a>
        </div>
        <div className="list-item__split-content">
          {imageSrcWide && (
            <div
              className="list-item__media js-list-item-clickable"
              data-location={contentUrl}
              onClick={() => (window.location = contentUrl)}
            >
              <img
                srcSet={imageSrcWide}
                alt=""
                sizes="(min-width: 780px) 270px, 100vw"
              />
            </div>
          )}
          <div className="list-item__content">
            <div
              className="list-item__description"
              dangerouslySetInnerHTML={{ __html: body }}
            />
          </div>
        </div>
      </div>
    );
  }
}

const { arrayOf, string, bool } = PropTypes;
ResultItem.propTypes = {
  date: string.isRequired,
  authors: arrayOf(string),
  clients: arrayOf(string),
  title: string.isRequired,
  body: string.isRequired,
  contentUrl: string.isRequired,
  displayUrl: string,
  contentType: string,
  location: string,
  imageSrcWide: string,
  featured: bool,
};
